import { CircularProgress } from '@mui/material'
import React from 'react'

type Props = {
  size?: number
  style?: React.CSSProperties
}
export const Spinner: React.FC<Props> = (props) => {
  const { style, size } = props
  const fullStyle = style || {}
  if (size) {
    fullStyle.width = size
    fullStyle.height = size
  }
  return <CircularProgress style={fullStyle} />
}
